import { render, staticRenderFns } from "./GeofenceReportDetails.vue?vue&type=template&id=4707af6a&scoped=true&"
import script from "./GeofenceReportDetails.vue?vue&type=script&lang=js&"
export * from "./GeofenceReportDetails.vue?vue&type=script&lang=js&"
import style0 from "./GeofenceReportDetails.vue?vue&type=style&index=0&id=4707af6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4707af6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4707af6a')) {
      api.createRecord('4707af6a', component.options)
    } else {
      api.reload('4707af6a', component.options)
    }
    module.hot.accept("./GeofenceReportDetails.vue?vue&type=template&id=4707af6a&scoped=true&", function () {
      api.rerender('4707af6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Reports/GeofenceReportDetails.vue"
export default component.exports